import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "../_keys";
import { Routes } from "../_routes";

import { urlMaker } from "utils";
import { onResponseUpdateApkVersion } from "./helpers";

export const updateApkVersion = async ({ id, ...data }: UpdateApkVersionReqT) =>
  axios.put(urlMaker(Routes.UPDATE_APK_VERSION, id), { ...data });

export const useUpdateApkVersion = () =>
  useMutation({
    mutationKey: [Keys.UPDATE_APK_VERSION],
    mutationFn: updateApkVersion,
    onSettled: onResponseUpdateApkVersion,
    cacheTime: Infinity,
  });
